import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, FrownIcon, ClockIcon, HeartIcon } from 'lucide-react';
export function PainPoints() {
  const painPoints = [{
    icon: <XIcon className="w-6 h-6 text-[#00A86B]" data-id="element-203" />,
    title: 'Tu Air Fryer junto polvo o lo usás solo para milanesas y papas.',
    desc: 'Lo compraste con ilusión (o te lo regalaron) y ahí está en la mesada, desaprovechado. Sentís que le sacás el 10% del potencial que tiene.'
  }, {
    icon: <FrownIcon className="w-6 h-6 text-[#00A86B]" data-id="element-204" />,
    title: 'Empezaste dietas mil veces y las abandonaste en 2 semanas.',
    desc: 'No es falta de voluntad. Es que no tenías un plan armado con recetas ricas y fáciles que se adapten a tu vida real. Cuando la dieta es puro sacrificio, es imposible sostenerla.'
  }, {
    icon: <ClockIcon className="w-6 h-6 text-[#00A86B]" data-id="element-205" />,
    title: 'No podés pasarte media hora pensando qué cocinar cada día.',
    desc: 'Entre el trabajo, la casa y las responsabilidades, lo último que querés es ponerte a inventar comida. Y así siempre terminás en la rotisería, el delivery o repitiendo lo mismo.'
  }, {
    icon: <HeartIcon className="w-6 h-6 text-[#00A86B]" data-id="element-206" />,
    title: 'Sentís que tu cuerpo te está pidiendo un cambio.',
    desc: 'Querés bajar esos kilos de más. O te preocupa el azúcar en sangre. O esa inflamación intestinal que no se va. O simplemente estás cansada de depender del café para funcionar y querés mirarte al espejo con otra energía.'
  }];
  return <section className="bg-white py-12 px-4 md:py-20" data-id="element-207">
      <div className="max-w-[800px] mx-auto" data-id="element-208">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-209">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-gray-900 mb-4" data-id="element-210">
            ¿Tenés Air Fryer pero seguís haciendo{' '}
            <span className="text-[#00A86B]" data-id="element-211">siempre lo mismo</span>?
          </h2>
          <p className="text-gray-500 text-base md:text-lg" data-id="element-212">
            Si llegaste hasta acá, probablemente te sentís identificada con
            alguna de estas situaciones.
          </p>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-213">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col sm:flex-row gap-4 p-5 rounded-2xl bg-gray-50 border border-gray-100 hover:shadow-md transition-shadow" data-id="element-214">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-[#00A86B]/10 flex items-center justify-center" data-id="element-215">
                {point.icon}
              </div>
              <div data-id="element-216">
                <h3 className="font-heading font-bold text-gray-900 mb-2" data-id="element-217">
                  {point.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed" data-id="element-218">
                  {point.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-[#00A86B] rounded-2xl p-6 md:p-8 text-center shadow-lg" data-id="element-219">
          <p className="text-white font-heading font-bold text-lg md:text-xl mb-2" data-id="element-220">
            El problema nunca fue tu motivación.
          </p>
          <p className="text-white/90 text-sm md:text-base" data-id="element-221">
            El problema fue no tener las recetas correctas: adaptadas a tu Air
            Fryer, con ingredientes que conseguís fácil, explicadas de una
            manera simple y listas para usar hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}